import { EntityAction, entityNames } from '../Entities';

// Keys to match (case-insensitive)
const keywords = [
	'client',
	'loan',
	'savingaccount',
	'saving',
	'FAMILYMEMBERS',
	'document',
	'datatable',
	'collateral',
	'ADDRESS',
	'transfer',
	'GLACCOUNT',
	'GLCLOSURE',
	'GLIMLOAN',
	'GROUP',
	'GSIMACCOUNT',
	'GUARANTOR',
	'JOURNALENTRY',
	'RECURRINGDEPOSITACCOUNT',
	'REPORT',
	'SHAREACCOUNT',
	'STAFF',
	'STANDINGINSTRUCTION',
	'TELLER',
	'USER',
]
	.map(k => k.toLowerCase())
	.filter(v => !v.includes('product'));

export const priorityOrder = [
	'client',
	'savingsaccount',
	'loan',
	'group',
	'transfer',
	'journalentry',
	'saving',
];
const skipList = [
	'product',
	'mapping',
	'week',
	'day',
	'month',
	'details',
	'check',
	'summary',
	'mail',
	'tax',
];

// Filter and sort entityNames
export const filteredEntityNames = Object.entries(entityNames)
	.filter(([key]) => {
		const lowerKey = key.toLowerCase();
		return (
			!key.includes(' ') &&
			keywords.some(keyword => lowerKey.includes(keyword)) &&
			!skipList.find(v => lowerKey.includes(v))
		);
	})
	.sort(([keyA], [keyB]) => {
		const a = keyA.toLowerCase();
		const b = keyB.toLowerCase();
		const getPriority = (k: string) => priorityOrder.findIndex(p => k.includes(p));

		const prioA = getPriority(a);
		const prioB = getPriority(b);

		if (prioA !== -1 && prioB !== -1) return prioA - prioB;
		if (prioA !== -1) return -1;
		if (prioB !== -1) return 1;
		return a.localeCompare(b);
	})
	.reduce(
		(acc, [key, value]) => {
			acc[key] = value;
			return acc;
		},
		{} as Record<string, EntityAction>,
	);
